import React, { useState } from "react";
import AddTaskSharpIcon from "@mui/icons-material/AddTaskSharp";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { Input } from "../utility/HexInput/InputBox";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import { TimeFormatterV2 } from "../TimeFormatter";
import { Spinner } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import Select from "react-select";
import Hexapi from "../utility/HexAPI/Hexapi";

function Followupinsert({
  agentID,
  EnquiryID,
  refreshActionModal,
  RemoveIndex,
  StageID,
}) {
  const [modalshow, setmodalshow] = useState(false);
  const [isfollowuploading, setisfollowuploading] = useState(false);
  const [isEditing, setisEditing] = useState(false);
  const [followDate, setfollowDate] = useState("");
  const [callfeedback, setcallfeedback] = useState("");
  const [stageid, setstageid] = useState("");
  const [productID, setproductID] = useState("");
  const [leadwithID, setleadwithID] = useState(agentID);
  const [followTime, setfollowTime] = useState("09:30");
  const [reminder, setreminder] = useState(false);
  const [showfollowupdate, setshowfollowupdate] = useState(false);
  const [showstagereason, setshowstagereason] = useState([]);
  const [callstage, setcallstage] = useState([]);
  const [callfeedbackarr, setcallfeedbackarr] = useState([]);
  const [highlightedIndex, sethighlightedIndex] = useState(-1);
  const [contactid, setcontactid] = useState(-1);
  const [selectedOption, setselectedOption] = useState(null);
  const [filteredOptions, setfilteredOptions] = useState("");
  const [remark, setremark] = useState("");
  const [productList, setproductList] = useState([]);
  const [contactlist, setcontactlist] = useState([]);
  const [callStatusOptions, setcallStatusOptions] = useState([]);
  const [nextstep, setnextstep] = useState("");
  const [textarea, settextarea] = useState("");
  const [crossIcon, setcrossIcon] = useState("");
  const [ClosingDate, setClosingDate] = useState(
    new Date().toJSON().slice(0, 10),
  );
  const [AgentList, setAgentList] = useState([]);
  const [stageprogress, setstageprogress] = useState([]);
  const resetForm = () => {
    setmodalshow(false);
    setisfollowuploading(false);
    setisEditing(false);
    setfollowDate("");
    setcallfeedback("");
    setstageid("");
    setproductID("");
    setleadwithID(agentID);
    setfollowTime("09:30");
    setreminder(false);
    setshowfollowupdate(false);
    setshowstagereason([]);
    setcallstage([]);
    setcallfeedbackarr([]);
    sethighlightedIndex(-1);
    setcontactid(-1);
    setselectedOption(null);
    setfilteredOptions("");
    setremark("");
    setproductList([]);
    setcontactlist([]);
    setcallStatusOptions([]);
    setnextstep("");
    settextarea("");
    setcrossIcon("");
    setClosingDate(new Date().toJSON().slice(0, 10));
    setAgentList([]);
    setstageprogress([]);
  };
  const handleOptionClick = (option) => {
    setremark(option.label);
    setselectedOption(option);
    sethighlightedIndex(-1);
  };
  const handleoptionchange = (option) => {
    setselectedOption(option);
    setremark(option.value);
    setisEditing(false);
  };
  const handleChangeselectremark = (value) => {
    if (!isEditing) {
      setisEditing(true);
    }
    setremark(value);
    if (value === "") {
      setisEditing(false);
    }
  };
  const checkstage = (event) => {
    const { value, checked } = event.target;

    setshowstagereason((prev) => {
      if (checked) {
        return [...prev, value];
      } else {
        return prev.filter((item) => item !== value);
      }
    });
  };
  const getdatafollow = async () => {
    setisfollowuploading(true);
    let obj = {
      query: `[dbo].[HCMS_Proc_FollowUpForm_GetData] @EnuiryID='{0}',@AgentID='{1}'`,
      queryArr: [`${EnquiryID}`, `${agentID}`],
    };
    const resp = await Hexapi(obj);
    setisfollowuploading(false);
    if (resp) {
      setcallfeedbackarr(resp.callfeedback);
      setAgentList(resp.agent);
      setcallStatusOptions(resp?.remarks);
      setleadwithID(resp?.leadwithagent[0]?.agentid);
      setreminder(false);
      setstageprogress(resp?.stage);
      setstageid(StageID);
    }
  };
  const storestageprogress = (e) => {
    if (e.target.value == "8") {
      setshowfollowupdate(true);
    } else {
      setshowfollowupdate(false);
    }
    setstageid(e.target.value);
    setcallstage([]);
    const obj = {
      query: `[dbo].[HCMS_Proc_FollowUpForm_Stage_OnChange]@StageID='{0}', @EnquiryID='{1}'`,
      queryArr: [`${e.target.value}`, `${EnquiryID}`],
    };
    Hexapi(obj)
      .then((resp) => {
        if (resp && resp.reason) {
          setcallstage(resp.reason);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getTopBarColor = () => {
    if (!Array.isArray(stageprogress) || !stageid) return "#B0BEC5";

    const stage = stageprogress.find(
      (s) => Number(s.stageid) === Number(stageid),
    );

    return stage?.stagecolor
      ? `#${stage.stagecolor.substring(0, 6)}`
      : "#B0BEC5";
  };
  const handleupdatebutton = () => {
    const combinedDateTime = new Date(`${followDate}T${followTime}:00`);

    const isValidDate =
      !isNaN(combinedDateTime.getTime()) &&
      combinedDateTime.getFullYear() >= 1753 &&
      combinedDateTime.getFullYear() <= 9999;

    if (!isValidDate) return Swal.fire({ text: "Invalid Date" });

    if (callstage.length > 0 && showstagereason.length === 0) {
      return Swal.fire({ text: "At least one reason is required" });
    }

  
    if (!followDate) return Swal.fire({ text: "Enter Date" });
    if (!stageid) return Swal.fire({ text: "Enter Stage" });
    if (!leadwithID)
      return Swal.fire({ text: "Please select Lead with Agent" });
    
    if (!callfeedback)
      return Swal.fire({ text: "Please provide Call Feedback" });
    setisfollowuploading(true);
    const reasonText = showstagereason.join(",");
    const combinedRemarks =
      callstage.length === 0 ? remark : `${remark} (${reasonText})`;

    const obj = {
      query: `[dbo].[HCMS_Proc_Followupdate_insert] 
        @CandidateID='{0}',
        @AgentID='{1}',
        @FollowupDate='{2}',
        @Remarks='{3}',
        @StageID='{4}',
        @NextStep='{5}',
        @LeadWithID='{6}',
        @CallFeedback='{7}',
        @Reminder='{8}'`,
           
      queryArr: [
        `${EnquiryID}`,
        `${agentID}`,
        `${TimeFormatterV2(
          combinedDateTime,
          "fulldate",
          "YYYY-MM-DD HH:mm:ss",
        )}`,
        `${combinedRemarks}`,
        `${stageid}`,
        `${nextstep}`,
        `${leadwithID}`,
        `${callfeedback}`,
        `${reminder}`,
      ],
    };

    Hexapi(obj)
      .then((resp) => {
        console.log(resp,"cgfehghdkjwxbdjxkz");
        const result = resp?.[""]?.[0];
        if (!result) return;

        Swal.fire({
          text: result.msg,
          confirmButtonText: "OK",
        }).then(() => {
          if (result.command !== 0) {
            resetForm();
            if (agentID !== leadwithID) {
              RemoveIndex();
              refreshActionModal();
            } else {
              refreshActionModal();
            }
          }
        });
      })
      .catch(() => {
        Swal.fire({ text: "Something went wrong" });
      })
      .finally(() => {
        setisfollowuploading(false);
      });
  };
  return (
    <>
      <Tooltip title="Update Follow Up">
        <IconButton
          onClick={() => {
            getdatafollow();
            setmodalshow(true);
          }}
        >
          <AddTaskSharpIcon />
        </IconButton>
      </Tooltip>
      <Modal
        size="lg"
        scrollable={true}
        show={modalshow}
        onHide={() => resetForm()}
        keyboard={false}
        backdrop="static"
        style={{ backgroundColor: "rgba(0,0,0,0.9)" }}
        centered
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 20px",
            alignItems: "center",
            borderBottom: "1px solid #ddd",
            background: getTopBarColor(),
          }}
        >
          <div>
            <div>
              <p style={{ fontWeight: "500" }}>Follow Update Form</p>
              <h6>
                Enquiry ID : <span>{EnquiryID}</span>
              </h6>
            </div>
          </div>

          {!isfollowuploading && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <div>
                <button
                  className="btnclss"
                  onClick={(e) => {
                    handleupdatebutton();
                  }}
                >
                  SUBMIT
                </button>
              </div>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => resetForm()}
              />
            </div>
          )}
        </div>
        {isfollowuploading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "40vh",
              alignItems: "center",
            }}
          >
            <Spinner color="red" animation="border" variant="dark" />
          </div>
        ) : (
          <Modal.Body style={{ padding: "10px", overflowX: "hidden" }}>
            <div className="row">
              <div className="col-9" style={{ marginBottom: "10px" }}>
                {!isEditing ? (
                  <>
                    <label style={{ fontWeight: "600" }}>Remark</label>
                    <Select
                      value={selectedOption}
                      onChange={handleoptionchange}
                      autoFocus={true}
                      options={callStatusOptions || []}
                      placeholder="Select a remark or type"
                      inputValue={isEditing ? remark : undefined}
                      onInputChange={(value) => {
                        if (value && !isEditing) {
                          setTimeout(() => {
                            handleChangeselectremark(value);
                          }, 100);
                          setisEditing(true);
                        }
                      }}
                      menuPlacement="bottom"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menuList: (base) => ({
                          ...base,
                          maxHeight: 350,
                          overflowY: "auto",
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          columnGap: "10px",
                          padding: "8px",
                        }),
                        option: (base, { isFocused }) => ({
                          ...base,
                          whiteSpace: "normal",
                          padding: "8px",
                          fontSize: "14px",
                          cursor: "pointer",
                          borderRadius: "6px",
                          backgroundColor: isFocused ? "#1250ac99" : "#fff",
                          color: isFocused ? "white" : "#000",
                          transition: "background 0.2s",
                        }),
                      }}
                    />
                  </>
                ) : (
                  <div style={{ marginTop: "10px", position: "relative" }}>
                    <label style={{ fontWeight: "600" }}>Remark</label>
                    <div
                      className="InlineInputBox"
                      id="inlineInputBox"
                      style={{ position: "relative" }}
                    >
                      <textarea
                        className="form-control"
                        value={remark}
                        onChange={(e) =>
                          handleChangeselectremark(e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "8px 30px 8px 8px",
                          fontSize: "16px",
                          resize: "none",
                          overflow: "hidden",
                        }}
                        rows={1}
                        ref={(el) => settextarea(el)}
                        autoFocus
                        onInput={(e) => {
                          const cursorPos = e.target.selectionStart;
                          e.target.style.height = "auto";
                          e.target.style.height = e.target.scrollHeight + "px";
                          e.target.selectionStart = cursorPos;
                          e.target.selectionEnd = cursorPos;
                          if (crossIcon) {
                            crossIcon.style.top =
                              e.target.scrollHeight - 24 + "px";
                          }
                        }}
                      />

                      <RxCross2
                        ref={(el) => (crossIcon = el)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          cursor: "pointer",
                          top: textarea
                            ? textarea.scrollHeight - 24 + "px"
                            : "8px",
                        }}
                        onClick={() => {
                          setisEditing(false);
                          setremark("");
                        }}
                      />
                      {remark &&
                        !selectedOption &&
                        filteredOptions.length > 0 && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              width: "100%",
                              borderRadius: "8px",
                              border: "1px solid #ccc",
                              background: "#fff",
                              maxHeight: "300px",
                              overflowY: "auto",
                              zIndex: 9999,
                              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                              marginTop: "4px",
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              columnGap: "8px",
                              padding: "8px",
                            }}
                          >
                            {filteredOptions.map((opt, index) => (
                              <div
                                key={opt.value}
                                onMouseEnter={() => sethighlightedIndex(index)}
                                onClick={() => handleOptionClick(opt)}
                                style={{
                                  padding: "8px",
                                  cursor: "pointer",
                                  backgroundColor: "#fff",
                                  borderRadius: "6px",
                                  color:
                                    index === highlightedIndex
                                      ? "white"
                                      : "#000",
                                  transition: "all 0.2s ease",
                                  fontSize: "14px",
                                  border:
                                    index === highlightedIndex
                                      ? "1px solid transparent"
                                      : "1px solid transparent",
                                }}
                                onMouseOver={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#1250ac99";
                                }}
                                onMouseOut={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    index === highlightedIndex
                                      ? "#fff"
                                      : "#fff";
                                  e.currentTarget.style.border =
                                    "1px solid transparent";
                                }}
                              >
                                {opt.label}
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  </div>
                )}
              </div>
              <div
                className="col-3"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <input
                  className="form-check-input"
                  name={"Reminder"}
                  type="checkbox"
                  value={reminder}
                  onChange={() => setreminder(reminder == 1 ? 0 : 1)}
                  checked={reminder}
                />
                <label htmlFor={"Reminder"} style={{ marginLeft: "5px" }}>
                  Reminder Me
                </label>
              </div>
            </div>
            <div className="row">
              <div className="col-8">
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label
                        htmlFor="nextFollowDate"
                        className="form-label fw-semibold"
                        style={{ fontWeight: 500 }}
                      >
                        Next Follow Date <span className="text-danger">*</span>
                      </label>

                      <div className="d-flex gap-2 w-100">
                        <input
                          type="date"
                          className="form-control custom-datetime flex-grow-1"
                          value={followDate}
                          onChange={(e) => setfollowDate(e.target.value)}
                          required
                          style={{ width: "60%" }}
                        />

                        <input
                          type="time"
                          className="form-control custom-datetime"
                          style={{ width: "40%" }}
                          value={followTime}
                          onChange={(e) => {
                            setfollowTime(e.target.value);
                            setreminder(true);
                          }}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-6">
                    <div>
                      {contactlist.length > 0 && (
                        <>
                          <label
                            style={{
                              fontSize: 16,
                              padding: 0,
                              fontWeight: "500",
                              marginBottom: "4px",
                            }}
                          >
                            Contact Number :&nbsp;
                            <span className="error" style={{ color: "red" }}>
                              *
                            </span>
                          </label>
                          <select
                            className="form-control"
                            aria-label="Default select example"
                            value={contactid}
                            onChange={(e) => {
                              setcontactid(e.target.value);
                            }}
                          >
                            <option value="" disabled selected>
                              select
                            </option>
                            {contactlist.map((item) => {
                              return (
                                <>
                                  <option
                                    value={item.contactid}
                                    key={item.contactid}
                                  >
                                    {item.contactnumber}({item.customername})
                                  </option>
                                </>
                              );
                            })}
                          </select>
                        </>
                      )}
                    </div>
                  </div> */}

                  {/* <div className="col-6" style={{ marginTop: "10px" }}>
                    <label
                      style={{
                        fontSize: 16,
                        padding: 0,
                        fontWeight: "500",
                      }}
                    >
                      Product :&nbsp;
                      <span className="error" style={{ color: "red" }}>
                        *
                      </span>
                    </label>
                    <select
                      className="form-control"
                      aria-label="Default select example"
                      value={productID}
                      onChange={(e) => {
                        setproductID(e.target.value);
                      }}
                    >
                      <option value="" disabled selected>
                        select
                      </option>
                       {productList.length > 0 && productList.map((item) => {
                        return (
                          <option value={item.productid} key={item.productid}>
                            {item.product}
                          </option>
                        );
                      })} 
                    </select>
                  </div> */}
                  <div className="col-6" style={{ marginTop: "10px" }}>
                    <Input
                      htmlFor={"Next Step"}
                      type={"text"}
                      label={"Next Step"}
                      labelStyle={{ fontWeight: "600" }}
                      value={nextstep}
                      onChange={(e) => setnextstep(e.target.value)}
                    />
                  </div>

                  <div className="col-6" style={{ marginTop: "10px" }}>
                    <div>
                      <label
                        style={{
                          fontSize: 16,
                          padding: 0,
                          fontWeight: "500",
                        }}
                      >
                        Lead with :&nbsp;
                        <span className="error" style={{ color: "red" }}>
                          *
                        </span>
                      </label>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        value={leadwithID}
                        onChange={(e) => {
                          setleadwithID(e.target.value);
                        }}
                      >
                        <option value="" disabled selected>
                          select
                        </option>
                        {AgentList.length > 0 && AgentList.map((item) => {
                          return (
                            <option value={item.agentid} key={item.agentid}>
                              {item.agentname}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  {stageprogress.length > 0 && (
                    <div className="col-6" style={{ marginTop: "10px" }}>
                      <label htmlFor="marital" style={{ fontWeight: "600" }}>
                        Stage
                        <span className="error" style={{ color: "red" }}>
                          *
                        </span>
                      </label>
                      <select
                        className="form-control"
                        name="stageid"
                        value={stageid}
                        onChange={(e) => storestageprogress(e)}
                      >
                        <option value="" disabled selected>
                          Select
                        </option>
                        {stageprogress.map((s, index) => {
                          return (
                            <option key={index} value={s.stageid}>
                              {s.stage}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-4">
                <div>
                  {callfeedbackarr.length > 0 && (
                    <div>
                      <p style={{ fontWeight: "600", marginBottom: "10px" }}>
                        Call Feedback :&nbsp;
                        <span className="error" style={{ color: "red" }}>
                          *
                        </span>
                      </p>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          marginTop: "4px",
                        }}
                      >
                        {callfeedbackarr.map((item, index) => {
                          const id = `feedback-${index}`;
                          const isSelected = callfeedback === item.value;

                          return (
                            <Tooltip title={item.hint} disableInteractive>
                              <div
                                key={index}
                                onClick={() => setcallfeedback(item.value)}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  background: isSelected
                                    ? "rgba(18, 80, 172, 0.08)"
                                    : "transparent",
                                  border: isSelected
                                    ? "1px solid #1250AC"
                                    : "1px solid #ddd",
                                  borderRadius: "6px",
                                  padding: "4px 14px",
                                  cursor: "pointer",
                                  transition: "all 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background =
                                    "rgba(18, 80, 172, 0.05)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background = isSelected
                                    ? "rgba(18, 80, 172, 0.08)"
                                    : "transparent";
                                }}
                              >
                                <input
                                  type="radio"
                                  id={id}
                                  name="feedback"
                                  value={item.value}
                                  checked={isSelected}
                                  readOnly
                                  style={{
                                    accentColor: "#1250AC",
                                    width: "18px",
                                    height: "18px",
                                    cursor: "pointer",
                                  }}
                                />
                                <label
                                  htmlFor={id}
                                  style={{
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    fontWeight: isSelected ? "600" : "500",
                                    color: isSelected ? "#1250AC" : "#333",
                                    userSelect: "none",
                                  }}
                                >
                                  {item.value}
                                </label>
                              </div>
                            </Tooltip>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" style={{ marginTop: "10px" }}>
                {showfollowupdate == true ? (
                  <Input
                    htmlFor={"Subscription Date "}
                    type={"date"}
                    label={"Subscription Date"}
                    labelStyle={{ fontWeight: "600" }}
                    value={ClosingDate}
                    onChange={(e) => {
                      setClosingDate(e.target.value);
                    }}
                  />
                ) : null}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {callstage.length > 0 && (
                  <>
                    <h6 style={{ marginTop: "6px" }}>Conclusion Reason </h6>
                    <div style={{ marginBottom: "6px" }}>
                      {callstage.map((option) => (
                        <div
                          key={option.value}
                          id="Product"
                          style={{
                            display: "inline-block",
                            marginRight: "25px",
                            flexWrap: "wrap",
                            marginBottom: "10px",
                          }}
                        >
                          <input
                            className="form-check-input"
                            name={option.reason}
                            type="checkbox"
                            value={option.reason}
                            id={option.reasonid}
                            onChange={checkstage}
                            checked={showstagereason.includes(option.reason)}
                          />
                          <label
                            htmlFor={option.reasonid}
                            style={{ marginLeft: "5px" }}
                          >
                            {option.reason}
                          </label>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
}

export default Followupinsert;
